var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImplant(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "implant") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "implant"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.93,14.51A12.81,12.81,0,0,0,41.56,3.05a12.32,12.32,0,0,0-5.24.65,12.94,12.94,0,0,1-8.64,0,12.32,12.32,0,0,0-5.24-.65A12.81,12.81,0,0,0,11.07,14.51a13.07,13.07,0,0,0,2.8,9.56c1.22,1.52,2.14,6.25,2.78,8.1a4.29,4.29,0,0,0,4,2.83H43.31a4.29,4.29,0,0,0,4-2.83c.64-1.85,1.56-6.58,2.78-8.1A13.07,13.07,0,0,0,52.93,14.51ZM41.76,8.05A20.58,20.58,0,0,1,32,10.72a20.58,20.58,0,0,1-9.76-2.67,1,1,0,1,1,1-1.7A18.93,18.93,0,0,0,32,8.72a18.93,18.93,0,0,0,8.72-2.37,1,1,0,1,1,1,1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.05,61H36l1.22-2.33-11-1.3C26.73,58.48,27.34,59.64,28.05,61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.09,40l-1.35-.12.2-2.88H22.06l.07,1.1-1-.1a1,1,0,0,0-.18,2l22,2H43a1,1,0,0,0,.09-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.09,45l-1.69-.15.07-1L22.41,42.14l.07,1L21.09,43a1,1,0,0,0-.18,2l22,2H43a1,1,0,0,0,.09-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1,50l-1-.1.07-1.06L22.76,47.17l.06.91L22.1,48a1,1,0,0,0-.2,2l20,2H42a1,1,0,0,0,.1-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.12,55l-1-.12.58-1.11L23.41,52.15l.49,1L23.12,53a1,1,0,0,0-.24,2l17,2H40a1,1,0,0,0,.12-2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImplant);
export default __webpack_public_path__ + "static/media/implant.303b7e65736ae2ec920b2d6a09c28e98.svg";
export { ForwardRef as ReactComponent };